function Footer() {
  return (
    <footer className="footer">
      <p className="footer__paragraph">© 2023 Mesto Russia</p>
    </footer>
  );
}

export default Footer;